import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var toLazyImage = function toLazyImage(url, name, width, height) {
  var mimeType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '*';
  var image = {
    name: name,
    original: {},
    width: width,
    height: height
  };
  var imageType = getImageType(mimeType);

  if (isContentfulAsset(url) && imageType !== '*') {
    image.original['webp'] = "".concat(url, "?fm=webp&q=80");
  }

  image.original[imageType] = url;

  if (isContentfulAsset(url)) {
    var placeholderWidth = Math.floor(width / 20);
    var placeholderHeight = Math.floor(height / 20);
    image.placeholder = _defineProperty({}, imageType, "".concat(url, "?w=").concat(placeholderWidth, "&h=").concat(placeholderHeight));

    if (imageType !== '*') {
      image.placeholder.webp = "".concat(url, "?fm=webp&w=").concat(placeholderWidth, "&h=").concat(placeholderHeight);
    }
  }

  return image;
};

var getImageType = function getImageType(mimeType) {
  if (mimeType === 'image/jpg') {
    return 'jpg';
  }

  if (mimeType === 'image/png') {
    return 'png';
  }

  return '*';
};

var isContentfulAsset = function isContentfulAsset(url) {
  return url.includes('images.ctfassets.net');
};

export default toLazyImage;